
webpack.register(
    'components/common/video-tabs/video-tabs',
    function() {
        return require('components/common/video-tabs/video-tabs');
    },
    false
);
webpack.register(
    'components/live-tv-schedule/live-tv-schedule',
    function() {
        return require('components/live-tv-schedule/live-tv-schedule');
    },
    false
);
webpack.register(
    'components/broadcaster-search/broadcaster-search',
    function() {
        return require('components/broadcaster-search/broadcaster-search');
    },
    false
);
webpack.register(
    'components/video-landing/live-streaming-schedule/live-streaming-schedule',
    function() {
        return require('components/video-landing/live-streaming-schedule/live-streaming-schedule');
    },
    false
);
webpack.register(
    'components/viewing-schedule-tabs/viewing-schedule-tabs',
    function() {
        return require('components/viewing-schedule-tabs/viewing-schedule-tabs');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/common/video-tabs/video-tabs'/>\r\n<can-import from='components/live-tv-schedule/live-tv-schedule'/>\r\n<can-import from='components/broadcaster-search/broadcaster-search'/>\r\n<can-import from='components/video-landing/live-streaming-schedule/live-streaming-schedule'/>\r\n<can-import from='components/viewing-schedule-tabs/viewing-schedule-tabs'/>\r\n\r\n\r\n<div class=\"c-viewing-schedule-old\">\r\n    <div class=\"s-content\">\r\n        <div class=\"c-viewing-schedule-old__container\">\r\n            <viewing-schedule-tabs {(schedule-date)}=\"scheduleDate\"/>\r\n        </div>\r\n\r\n        <live-tv-schedule {(broadcasts)}=\"broadcasts\" {schedule-date}=\"scheduleDate\"/>\r\n        {{#if broadcasts.length}}\r\n            <div class=\"c-viewing-schedule-old__search\">\r\n                <broadcaster-search {schedule-date}=\"scheduleDate\"/>\r\n            </div>\r\n        {{/if}}\r\n        {{#if scheduleDate}}\r\n            <live-streaming-schedule {schedule-date}=\"scheduleDate\"/>\r\n        {{/if}}\r\n    </div>\r\n</div>\r\n");